/**
 * Small, seedable PRNG so scene dressing is stable between reloads.
 * Based on mulberry32.
 */
export function createRandom(seed = 1) {
  let state = seed >>> 0;

  const random = () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let value = state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };

  random.range = (min, max) => min + random() * (max - min);
  random.int = (min, max) => Math.floor(random.range(min, max + 1));
  random.pick = (items) => items[Math.floor(random() * items.length)];

  return random;
}
